module.exports = __webpack_public_path__ + "static/media/4ll23.b11bff7c.png";